import {MeasurementPrecisionTypes} from "@model";
import {removeLeadingZeros} from "./remove-leading-zeros";
import {stringTimeToPrecision} from "./string-time-precision";

export function resultTime(time?: string, measurementPrecisionType?: MeasurementPrecisionTypes | undefined): string {
    measurementPrecisionType = measurementPrecisionType ?? MeasurementPrecisionTypes.SECONDS;
    if (!time) {
        return '-';
    }
    const isNegative = time.startsWith('-');
    const absTime = isNegative ? time.slice(1) : time;
    const transformed = removeLeadingZeros(stringTimeToPrecision(absTime.replace(".000", ""), measurementPrecisionType));
    return isNegative ? '-' + transformed : transformed;
}